import React from 'react';
import { useLang } from '../contexts/LanguageContext';

/** Fallback header for Clients page while loading (uses i18n) */
export default function ClientsPageFallback() {
  const { t } = useLang();
  return (
    <div className="font-sans relative isolate" dir="rtl">
      <div className="clients-header" style={{ minHeight: '200px', padding: '1rem' }}>
        <div className="clients-header__top">
          <div className="clients-header__title-block">
            <div className="clients-header__title-content">
              <div className="clients-header__title-row">
                <h1 className="clients-header__title">{t('pages.clients.listTitle')}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
